function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3708"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3637",
  transform: "translate(12104 10918.696)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3708",
  d: "M-12091.813-10918.696a12.208 12.208 0 00-12.187 12.187c0 6.713 12.187 23.313 12.187 23.313s12.187-16.6 12.187-23.313a12.208 12.208 0 00-12.187-12.187zm0 18.487a6.3 6.3 0 116.3-6.3 6.281 6.281 0 01-6.3 6.3z"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellisse 519",
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(-12099 -10913.696)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3638"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 4752",
  d: "M19.331 17.285a.305.305 0 00-.442 0 .553.553 0 01-.789 0 1.184 1.184 0 00-1.09-.316 6.832 6.832 0 001.311-4.042.306.306 0 00-.158-.269l-1.579-.868V8.664a.95.95 0 00-.948-.947h-.315V6.296a.95.95 0 00-.947-.947h-1.737V4.244a.317.317 0 00-.316-.316.317.317 0 00-.316.316v1.105h-1.736a.95.95 0 00-.948.947v1.421h-.315a.95.95 0 00-.947.947v3.11l-1.579.869a.325.325 0 00-.158.269 6.644 6.644 0 001.31 4.026 1.212 1.212 0 00-.237-.031 1.183 1.183 0 00-.837.347.553.553 0 01-.789 0 .306.306 0 00-.442 0 .305.305 0 000 .442 1.191 1.191 0 001.674 0 .582.582 0 01.789 0 1.183 1.183 0 00.836.347.968.968 0 00.221-.016h.031a1.18 1.18 0 00.584-.316.582.582 0 01.789 0 1.186 1.186 0 00.837.347 1.186 1.186 0 00.837-.347.553.553 0 01.789 0 1.192 1.192 0 001.673 0 .553.553 0 01.789 0 1.113 1.113 0 00.6.316h.016a1.116 1.116 0 00.221.016 1.182 1.182 0 00.836-.347.552.552 0 01.79 0 1.191 1.191 0 001.673 0 .259.259 0 00.019-.411zM9.953 6.296a.317.317 0 01.315-.316h4.1a.317.317 0 01.316.316v1.421H9.948zM8.69 8.665a.316.316 0 01.316-.315h6.63a.316.316 0 01.316.315v2.763l-3.473-1.942a.286.286 0 00-.158-.031.291.291 0 00-.158.031L8.69 11.428z",
  fill: "#940000"
})));

function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.374 35.503"
  }, props), _ref);
}

export default SvgMarker;